import Rules, { ValidateRule } from '@lsfe/rules';

const NoBracketRule = new ValidateRule({
    validator(rule, value, cb) {
        if (/[【】]/.test(value)) {
            cb(new Error('不能包含【】符号'));
        } else {
            cb();
        }
    },
});

export const SKUNameMaxLength = 30;
export const CommodityNameMaxLength = 30;
export const MarketWordMaxLength = 8;

const commonSKUNameRule = [Rules.lenRange({ max: SKUNameMaxLength }, `名称最多${SKUNameMaxLength}个字`)];

const commonCommodiyNameRule = [
    Rules.lenRange({ max: CommodityNameMaxLength }, `名称最多${CommodityNameMaxLength}个字`),
    NoBracketRule,
];

const commonMarketWordRule = [
    Rules.lenRange({ max: MarketWordMaxLength }, `营销词最多${MarketWordMaxLength}个字`),
    NoBracketRule,
];

/**
 * 非扩城等其他场景，skuName 相关校验
 */
// eslint-disable-next-line import/prefer-default-export
export const skuNameRules = {
    skuName: [
        Rules.isRequired('sku名称必填'),
        ...commonSKUNameRule,
    ],
    commodityName: [
        Rules.isRequired('商品名称必填'),
        ...commonCommodiyNameRule,
    ],
    marketingWord: [
        ...commonMarketWordRule,
    ],
};
